import React from "react";
import { InputAdornment, Tooltip, Typography } from "@mui/material";
import { Lock } from "@mui/icons-material";

/**
 * Sinalização de campo bloqueado pelo perfil (RN-112q): cadeado à esquerda, dentro do campo, e o
 * texto "Restrito" no lugar do valor. Decisão de UX do Hilton (13/09): cadeado no campo, não no
 * rótulo; cor de aviso, não vermelho (vermelho é erro de validação).
 */
export const SENSITIVE_LABEL = "Restrito";
const LOCK_COLOR = "#adb5bd";

export const SensitiveLockIcon: React.FC = () => (
  <Tooltip title="Bloqueado para o seu perfil" arrow>
    <Lock sx={{ fontSize: 14, color: LOCK_COLOR }} />
  </Tooltip>
);

/**
 * Props para um TextField (texto ou select) bloqueado: desabilitado, vazio, com cadeado e
 * "Restrito". Espalhar por último para vencer `disabled`, `value` e `placeholder` do campo.
 */
export const sensitiveFieldProps = () => ({
  disabled: true,
  value: "",
  placeholder: SENSITIVE_LABEL,
  InputProps: {
    startAdornment: (
      <InputAdornment position="start">
        <SensitiveLockIcon />
      </InputAdornment>
    ),
  },
  SelectProps: {
    displayEmpty: true,
    renderValue: () => <span style={{ color: "#6c757d" }}>{SENSITIVE_LABEL}</span>,
  },
  error: false,
  helperText: undefined,
});

/** Célula de lista bloqueada: cadeado + "Restrito" no lugar do valor. */
export const SensitiveCell: React.FC = () => (
  <Typography component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, fontSize: "0.85rem", color: "#6c757d", fontStyle: "italic" }}>
    <SensitiveLockIcon />
    {SENSITIVE_LABEL}
  </Typography>
);
